<template>
    <el-header height="50">

        <div class="outer-container clearfix">
            <div class="left-side">
                <div class="logo-container">
                    <!-- Logo 图片或文字 -->
                    <img :src="logoRaw" alt="logo" class="logo-image" />
                </div>
            </div>
            <div class="left-side2">
                <div class="left-side2-container">
                    <el-dropdown size="medium" @command="handleDpCommand" style="margin-top: 8px;">
                        <el-button type="primary" round>
                            操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="a"><i class="el-icon-circle-close"></i>关闭全部</el-dropdown-item>
                            <el-dropdown-item command="b"><i class="el-icon-setting"></i>个人设置</el-dropdown-item>
                            <el-dropdown-item command="c"><i class="el-icon-switch-button"></i>退出系统</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <div class="right-side">
                <div class="right-side-container">
                    <el-tabs v-model="editableTabsValue" type="card" closable @tab-remove="removeTab" @tab-click="tabClick">
                        <el-tab-pane
                            v-for="(item, index) in editableTabs"
                            :key="item.name"
                            :label="item.title"
                            :name="item.name"
                            :path="item.path"
                        >
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>

    </el-header>
</template>

<script>
import Api from '../api/index'

export default {
  name: 'header_nav_menu',
  data() {
    return {
        activeIndex2: "home",
        selectionMenuId: "/home/dashboard",
        logoRaw: require("../assets/logo-48px.png"),
        userCenterIcon: require("../assets/user_purple.png"),
        modularFuns: [],

        editableTabsValue: 'a1',
        editableTabs: [
            {
                name: "a1",
                title: "首页",
                content: "",
                path: "/home/dashboard"
            }
        ],
        tabIndex: 2
    }
  },
  methods: {
    goBack() {
        console.log('go back');
    },
    addTab(targetName) {
        let newTabName = ++this.tabIndex + '';
        this.editableTabs.push({
            title: 'New Tab',
            name: newTabName,
            content: 'New Tab content'
        });
        this.editableTabsValue = newTabName;
    },
    tabClick(tab, event) {
        if(this.$route.path == tab.$attrs.path)
            return;
        this.$router.push(tab.$attrs.path);
    },
    removeTab(targetName) {
        let tabs = this.editableTabs;
        if(tabs.length === 1) {
            this.$message.error('最后一个Tabs不可以删除！');
            return;
        }
        let activeName = this.editableTabsValue;
        if (activeName === targetName) {
            tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
                let nextTab = tabs[index + 1] || tabs[index - 1];
                if (nextTab) {
                    activeName = nextTab.name;
                }
            }
            });
        }
        
        this.editableTabsValue = activeName;
        this.editableTabs = tabs.filter(tab => tab.name !== targetName);
    },
    removeAllTabs() {
        let newTabs = [];
        let tabs = this.editableTabs;
        let activeName = this.editableTabsValue;
        tabs.forEach((tab, index) => {
            if(tab.name == activeName) {
                newTabs.push(tab);
            }
        });
        this.editableTabs = newTabs;
    },
    handleDpCommand(command) {
        //this.$message('click on item ' + command);
        switch(command) {
            case "a":
                this.removeAllTabs();
                break;
            case "b":
                var path = "/sys/setting";
                var obj = {
                    id: "11",
                    name: "个人设置",
                    path: path
                };
                this.addTabPane(obj);
                this.$router.push(path);
                break;
            case "c":
                this.logout();
            default: break;
        }
    },
    loadModularFuns: function() {
        Api.GetFuns({}).then((res) => {
            if(res && res.code === 200) {
                var menuNavList = [];
                for(var i=0; i<res.data.length; i++) {
                    menuNavList.push({
                        funId: res.data[i].funId,
                        funName: res.data[i].funName,
                        funPath: res.data[i].funPath
                    });
                }
                this.modularFuns = menuNavList;
            } else if(res.code === 401) {
                this.$router.push("../Login");
            }
        });

        var url = window.location.href;
        if(url.split('/#')[1])
            this.selectionMenuId = url.split('/#')[1];
    },
    handleMenuItem: function(path) {
        //alert(path);
        this.$router.push(path);
        this.selectionMenuId = path; // this.$route.path;
    },
    handleSelect: function() {

    },
    handleNodePath: function(path) {
        //this.selectionMenuId = path;
    },
    addTabPane(obj) {
        let existsPath = false;
        let tabs = this.editableTabs;
        for(var i=0; i<tabs.length; i++) {
            if(tabs[i].path === obj.path) {
                existsPath = true;
                break;
            }
        }

        if(!existsPath) {
            this.editableTabs.push({
                title: obj.name,
                name: obj.id,
                content: '',
                path: obj.path
            });
        } else {
            console.log("菜单已存在！");
        }

        this.editableTabsValue = obj.id;
    },
    handleCommand(command) {
        //this.$message('click on item ' + command);
        if(command == "logout") {
            this.logout();
        } else if(command == "user") {
            //user center
        }
    },
    logout: function() {
        Api.UserLogout({}).then((res) => {
            if(res && res.code === 200) {
                // 退出登录成功
                console.log("退出登录成功");
                console.log(res);
            }
            this.$router.push("../Login");
        });
    }
  },
  mounted() {

    // 加载主导航菜单
    //this.loadModularFuns();
  }
}
</script>

<style>
.logo-container {
    height: 60px;
    text-align: center;
}
.logo-image {
    margin-top: 10px;
    width: 128px; 
    height: 40px;
}
.dom-person {
    float: right;
    margin: 10px 10px 0 0;
    height: 36px;
}

/* 外层容器，宽度100% */
.outer-container {
    width: 100%;
    background-color: #ffffff;
    padding: 0;
    box-sizing: border-box;
}

/* 清除浮动 */
.clearfix::after {
    content: "";
    display: table;
    clear: both;
}

/* 左侧固定宽度 */
.left-side {
    width: 200px;
    float: left;
    background-color: #cae3f1;
    color: #333333;
    padding: 0;
    box-sizing: border-box;
    border-bottom: #cccccc 1px solid;
}

.left-side2 {
    width: 110px;
    float: left;
    background-color: #ffffff;
    color: #333333;
    padding: 0;
    box-sizing: border-box;
    border-bottom: #cccccc 1px solid;
}

.left-side2-container {
    height: 50px;
    padding-top: 10px;
    text-align: center;
}

/* 右侧自适应宽度 */
.right-side {
    margin-left: 310px; /* 等于左侧宽度 */
    background-color: #ffffff;
    color: #333333;
    padding: 0;
    box-sizing: border-box;
}

.right-side-container {
    height: 50px;
    padding-top: 14px;
}

</style>